import { Command } from '../Command';
import { generateDefault } from '../../../lib/utils';
import { commandList } from '../../../lib/command-list';
import { accountEvent } from '../../../lib/constants';

const AccountEventCommand = Command.extend({
  detail: {
    event: Object.values(accountEvent),
    data: [Object]
  }
}).defaultTo(
  generateDefault({
    action: commandList.ACCOUNT_EVENT
  })
);

const OpenAccountCommand = Command.extend({
  detail: {
    section: String
  }
}).defaultTo(
  generateDefault({
    action: commandList.OPEN_ACCOUNT
  })
);

const GetAccountVersionCommand = Command.extend({}).defaultTo(
  generateDefault({
    action: commandList.GET_ACCOUNT_VERSION
  })
);

export { AccountEventCommand, OpenAccountCommand, GetAccountVersionCommand };
